








import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";

@Component({
  name: "uc-image"
})
export default class UcImageComponent extends Vue {
  onDeletePartner(){
     this.$emit("delete")
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/pages/components/uc-image.vue